import { render, staticRenderFns } from "./AddPuiForm.vue?vue&type=template&id=a158432c&"
import script from "./AddPuiForm.vue?vue&type=script&lang=js&"
export * from "./AddPuiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports